import React from 'react';
import PropTypes from 'prop-types';
import ErrorIcon from '@material-ui/icons/Error';

import styles from './ErrorAlert.css';


function ErrorAlert({ message }) {
  return (
    <div className={styles.container}>
      <ErrorIcon className={styles.icon} />
      <span>{message}</span>
    </div>
  );
}

ErrorAlert.propTypes = { message: PropTypes.string.isRequired };

export default ErrorAlert;
